import Axios from 'axios';

import { ROUTES } from '@/constants/routes';

const BASE_URL =
  import.meta.env.VITE_API_URL ?? 'https://app.supplierhq.io/api';

export const axios = Axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axios.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem('user');
    const token = user ? JSON.parse(user).accessToken : null;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// TODO: Refresh access token
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.message;

    if (message?.toLowerCase().includes('expired')) {
      localStorage.removeItem('user');
      window.location.href = ROUTES.SIGN_IN;
    }

    return Promise.reject(error);
  }
);
